// extracted by mini-css-extract-plugin
export var main_div = "ceo_banner-module--main_div--yKj+k";
export var image_div = "ceo_banner-module--image_div--I+nIF";
export var text_div = "ceo_banner-module--text_div--wYKCr";
export var btnOutline = "ceo_banner-module--btnOutline--zcTk1";